import { BoxInfo, MnemoLoading, ModalHandler, MSection, SuccessNotification, Title } from "components/misc";
import dayjs from "dayjs";
import { dateHelper, networkErrorHelper } from "libs";
import { Button, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col } from "design-react-kit";
import { newsletterService } from "libs/api/newsletterService";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { MInput } from "components/forms";

class NewsletterSubscribers extends Component {
  state = {
    loading: true,
    loadingError: false,
    isCancelOpen: false,
    cancelEmail: "",
    cancelError: "",
    stats: [],
  };

  componentDidMount() {
    this.loadRemote();
  }

  loadRemote() {
    this.setState({ loading: true, loadingError: false });

    newsletterService
      .getSubscribersStats()
      .then(({ data }) => {
        const { stats } = data.payload;

        this.setState({
          stats,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false, loadingError: true });
      });
  }

  onExportSubscribers = (activeOnly) => {
    const title = activeOnly ? "Esporta iscritti abilitati" : "Esporta tutti gli iscritti";
    const message = activeOnly ? (
      <span>
        Verrà esportata la lista degli <b>iscritti abilitati</b> alla newsletter. Vuoi procedere?
      </span>
    ) : (
      <span>
        Verrà esportata la <b> lista completa di tutti gli iscritti</b> (inclusi quelli <b>disabilitati</b>). Vuoi procedere?
      </span>
    );

    ModalHandler.show(null, title, message, null, () => this.confirmExportSubscribers(activeOnly));
  };

  confirmExportSubscribers = (activeOnly) => {
    this.setState({ loading: true });

    const filter = {};

    if (activeOnly) {
      filter.isCancelled = false;
    }

    newsletterService
      .exportSubscribers(filter)
      .then(({ data }) => {
        const name = activeOnly ? "newsletter_iscritti_attivi_" : "newsletter_iscritti_completo_";
        const originalName = name + dayjs().format("DD_MM_YYYY_HH_mm_ss") + ".xlsx";

        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", originalName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  toggleCancel = () => {
    this.setState((prevState) => ({
      isCancelOpen: !prevState.isCancelOpen,
      cancelEmail: "",
      cancelError: "",
    }));
  };

  onEmailChange = (_, value) => {
    this.setState({ cancelEmail: value, cancelError: "" });
  };

  confirmCancelSubscription = () => {
    const { cancelEmail } = this.state;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!cancelEmail || !emailRegex.test(cancelEmail)) {
      this.setState({ cancelError: "Inserisci un indirizzo email valido." });
      return;
    }

    this.setState({ loading: true });

    const payload = {
      cancelEmail,
    };

    newsletterService
      .cancelSubscription(payload)
      .then(() => {
        this.setState({
          loading: false,
        });
        this.toggleCancel();
        this.loadRemote();

        SuccessNotification.render("Iscritto disabilitato con successo", "Operazione completata");
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loading: false,
        });

        if (networkErrorHelper.is404(error)) {
          const message = networkErrorHelper.getErrorMessage(error);
          this.setState({ cancelError: message });
        } else {
          networkErrorHelper.notify(error);
          this.toggleCancel();
        }
      });
  };

  render() {
    const { cancelEmail, cancelError, loading, isCancelOpen, stats } = this.state;

    const subscribersTotal = stats.reduce((sumYear, group) => {
      const yearTotal = group.months.reduce((sumMonth, m) => sumMonth + parseInt(m.tot_subscribers), 0);
      return sumYear + yearTotal;
    }, 0);

    const isExportDisabled = loading || !stats || stats.length === 0;

    return (
      <>
        {loading && <MnemoLoading />}
        <Container className="m-4">
          <Title>Statistiche iscritti newsletter</Title>
          <MSection>
            <Row className="mb-4 mt-3 align-items-center">
              <Col md={6}>
                <h3 className="mb-0 ">Totale iscritti: {subscribersTotal}</h3>
              </Col>

              <Col>
                <Button className="mx-1 float-right" color="danger" onClick={this.toggleCancel}>
                  Cancella iscritto
                </Button>
                <Button
                  className="mx-1 float-right"
                  color="primary bg-dark"
                  onClick={() => this.onExportSubscribers(true)}
                  disabled={isExportDisabled}
                >
                  Esporta abilitati
                </Button>
                <Button
                  className="mx-1 float-right"
                  color="primary bg-dark"
                  onClick={() => this.onExportSubscribers(false)}
                  disabled={isExportDisabled}
                >
                  Esporta tutti
                </Button>
              </Col>
            </Row>

            {!stats || stats.length === 0 ? (
              <BoxInfo>Non ci sono dati da mostrare in database.</BoxInfo>
            ) : (
              <>
                <table className="MTable table table-bordered">
                  <tbody>
                    {stats.map((group) => {
                      const rows = [];

                      rows.push(
                        <tr key={group.year}>
                          <td colSpan="2" className="text-center table-secondary">
                            <h3 className="my-2">{group.year}</h3>
                          </td>
                        </tr>,
                      );

                      rows.push(
                        <tr key={`columns-${group.year}`}>
                          <th className="w-50">Mese</th>
                          <th className="w-50">Nuovi iscritti</th>
                        </tr>,
                      );

                      group.months.forEach((monthData, index) => {
                        rows.push(
                          <tr key={`${group.year}-${index}`}>
                            <td>{dateHelper.getMonthName(monthData.month)}</td>
                            <td>{monthData.tot_subscribers}</td>
                          </tr>,
                        );
                      });

                      return rows;
                    })}
                  </tbody>
                </table>
              </>
            )}
          </MSection>
        </Container>

        {/** Modale cancella iscritto */}
        <Modal isOpen={isCancelOpen} toggle={this.toggleCancel} centered size="lg">
          <ModalHeader toggle={this.toggleCancel}>Cancella iscritto</ModalHeader>
          <ModalBody>
            <p>Inserisci l'indirizzo email dell'iscritto che desideri cancellare dalla newsletter.</p>
            <Row className="mt-4">
              <Col>
                <MInput type="email" name="cancelEmail" value={cancelEmail} onChange={this.onEmailChange} />
                {cancelError && <div className="text-danger mt-2">{cancelError}</div>}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" outline onClick={this.toggleCancel}>
              Annulla
            </Button>
            <Button color="danger" onClick={this.confirmCancelSubscription}>
              Conferma cancellazione
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
export default withRouter(NewsletterSubscribers);
